const { makeStyles } = require("@material-ui/core");

export const useStyles = makeStyles((theme) => ({
  content: {
    ...theme.mainContentLG,
  },
  contentFeed: {
    maxWidth: "600px",
    minWidth: "600px",
    margin: "0 auto",
  },
  header: {
    position: "sticky",
    top: 0,
    width: "100%",
    zIndex: 100,
    padding: "0px 30px",

    background: "#fff",
    boxShadow: "0 4px 10px -4px rgba(0,0,0,.07)",
  },
}));
